// import has from 'lodash/has'
// import find from 'lodash/find'
import request from '@/lib/axios'
// import orderBy from 'lodash/orderBy'
// import Scout from '~/constants/scout'
// import * as UserAPI from '@/api/user'

// Using Apollo Provider to show the error
//////////////////////////////////////////////////
///////////////////////////////
/////////
// eslint-disable-next-line
// import { apolloProvider } from '@/main'
//////////

export const state = () => ({
  isAuthenticated: null,
  details: null,
  individualUser: null,
  teamUser: null,
  isTeam: false,
  teams: [],
  teamMembers: [],
  selectedDesigners: []
})

export const getters = {
  get (state, getters) {
    if (state.isTeam) {
      return getters.getTeamUser
    }
    return getters.getIndividualUser
  },
  getIndividualUser (state, getters, rootState, rootGetters) {
    return rootGetters['common/users/get'](state.individualUser)
  },
  getTeamUser (state, getters, rootState, rootGetters) {
    return rootGetters['common/users/get'](state.teamUser)
  },
  getTeams (state, getters, rootState, rootGetters) {
    return rootGetters['common/users/getList'](state.teams)
  },
  getMembers (state) {
    if (state.teamUser) {
      return state.teamMembers
    }
  },
  getMember: (state) => (uuid) => {
    return find(state.teamUser.members, { uuid })
  },
  showModalName (state, getters) {
    if (state.isAuthenticated && getters.get.first_name === null) {
      return true
    }
    return false
  },
  isAdmin (state, getters) {
    if (state.isAuthenticated && getters.get.role === 'admin') {
      return true
    }
    return false
  },
  selectedDesigner (state, getters, rootState, rootGetters) {
    return rootGetters['common/users/getList'](state.selectedDesigners)
  }
}

export const mutations = {
  setNotLoggedIn (state) {
    state.isAuthenticated = false
    state.individualUser = null
    state.teamUser = null
  },
  setIndividualUser (state, uuid) {
    state.individualUser = uuid
    state.isAuthenticated = true
  },
  setTeamUser (state, uuid) {
    state.teamUser = uuid
  },
  setUserType (state, type = 'personal') {
    state.isTeam = type === 'team'
  },
  setTeams (state, teams) {
    state.teams = teams.map(team => team.uuid)
  },
  setMembers (state, uuids) {
    state.teamMembers = uuids
  },
  setSelectedDesigners (state, data) {
    state.selectedDesigners = data.map(user => user.uuid)
  }
}

export const actions = {
  async fetch ({ commit, state, dispatch, rootState }) {
    try {
      let response = await request({
        route: 'auth',
        params: {
          subscriptions: true
        }
      })
      console.log('Authenticated')
      dispatch('login', response.data.response)
    } catch (e) {
      console.log('Not Authenticated')
      commit('setNotLoggedIn')
    }

    // // If User is Team
    // if (user.is_team) {
    //   // Set Appropriate Users
    //   commit('setIndividualUser', user.active_member.uuid)
    //   commit('common/users/add', user.active_member, { root: true })

    //   // Set Team User
    //   commit('setTeamUser', user.uuid)

    //   // Add Members to the Team
    //   dispatch('addMembers', user.members)
    //   commit('setMembers', user.members.map(u => u.uuid))
    // } else {
    //   commit('setIndividualUser', user.uuid)
    //   commit('common/users/add', user, { root: true })
    // }
  },
  login ({ commit }, { auth, member }) {
    // Add User to common store
    commit('common/users/add', auth, { root: true })

    // Check User type,
    // If user is team, then fetch main user
    if (auth.type === 'team') {
      commit('setTeamUser', auth.uuid)

      // Fetch Individual User
      let admin = member
      commit('common/users/add', admin, { root: true })
      commit('setIndividualUser', admin.uuid)
    } else {
      commit('setIndividualUser', auth.uuid)
    }

    // Set User type for validations
    commit('setUserType', auth.type)

    // Set Token if it's returned from backend
    if (auth.oauth_access_token) {
      commit('settings/setToken', auth.oauth_access_token, { root: true })
    }
  },
  async getSelectedDesigners ({ commit }) {
    let response = await request({
      route: 'selected.contributors'
    })
    const contributors = response.data.response.selected_contributors.data
    commit('common/users/add', contributors, { root: true })
    commit('setSelectedDesigners', contributors)
  },
  logout ({ commit, dispatch }, user) {
    commit('settings/setToken', null, { root: true })
    commit('setNotLoggedIn')

    // Clear Apollo Cache
    // Object.values(apolloProvider.clients)
    //   .forEach(client => client.cache.reset())
  }
  //   async fetchTeams ({ commit, state, dispatch }) {
  //     let teams = await UserAPI.getTeams(true)
  //     // Add Team Members
  //     // We can't add member to common store,
  //     // As he might have different roles in different teams
  //     // teams.map(team => {
  //     //   commit('common/users/add', team.members, { root: true })
  //     //   team.members = team.members.map(member => member.uuid)
  //     // })
  //     // Add Team as User to common store
  //     commit('common/users/add', teams, { root: true })
  //     commit('setTeams', teams)
  //   },
  //   async switchTeam ({ commit }, uuid) {
  //     await UserAPI.switchTeam(uuid)
  //   },
  //   async switchUser ({ commit }, uuid) {
  //     await UserAPI.switchUser(uuid)
  //   },
  //   addMembers ({ commit, state }, users) {
  //     // Set the param in each member to show whether he's the active user or not
  //     let members = users.map(m => {
  //       return {
  //         ...m,
  //         isActive: state.individualUser === m.uuid
  //       }
  //     })
  //     commit('common/users/add', members, { root: true })
  //   },
  //   refreshProfilePhoto ({ state, commit }) {
  //     commit('common/users/refreshProfilePhoto', state.individualUser, { root: true })
  //   },
  //   refreshCompanyPhoto ({ state, commit }) {
  //     commit('common/users/refreshCompanyPhoto', state.individualUser, { root: true })
  //   }
}
